<template>
  <card-dialog
    v-model="modalVisible"
    max-width="700px"
    :title="'Assign ' + playerIds.length + ' Players To Radio'"
  >
    <v-card-text
      class="pa-6"
    >
      <validation-observer ref="validation">
        <div class="mb-2 font-weight-bold">
          Radio
        </div>
        <validation-provider
          v-slot="{ errors }"
          rules="required"
        >
          <v-autocomplete
            v-model="radioId"
            :loading="radios.loading"
            :items="radios.data"
            item-value="id"
            item-text="title"
            outlined
            :error-messages="errors"
            placeholder="Select radio"
          >
            <template v-slot:item="{ item: radio }">
              <v-list-item-content>
                <v-list-item-title>
                  {{ radio.title }}
                </v-list-item-title>
                <v-list-item-subtitle :class="{ 'text--disabled': !radio.client }">
                  {{ radio.client ? 'For ' + radio.client.name : 'For general use' }}
                  <span
                    v-if="radio.is_child"
                    class="ml-2"
                  >
                    &middot;
                    Child of <strong>{{ radio.parent ? radio.parent.title : 'N/A' }}</strong>
                  </span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </validation-provider>
      </validation-observer>
    </v-card-text>
    <template v-slot:actions>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          color="primary"
          :loading="submitting"
          @click="submit()"
        >
          Save
        </v-btn>
      </v-card-actions>
    </template>
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog'
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import Players from '@/services/Players'
import Radios from '@/services/Radios'

export default {
  name: 'AssignToRadioDialog',
  components: { CardDialog },
  mixins: [deleteConfirmationMixin],
  props: {
    playerIds: {
      type: Array,
      default: () => ([])
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      submitting: false,
      radios: {
        loading: false,
        data: []
      },
      radioId: undefined
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  created() {
    this.fetchRadios()
  },
  methods: {
    async fetchRadios() {
      this.radios.loading = true

      try {
        this.radios.data = (await Radios.fetch({ include_children: true }))
      } catch (e) {

      } finally {
        this.radios.loading = false
      }
    },
    async submit() {
      if (!(await this.$refs.validation.validate())) {
        return
      }

      await this.save()
    },
    async save() {
      try {
        this.submitting = true

        const result = await Players.assignToRadio(this.playerIds, this.radioId)

        this.$emit('player:assigned', result)

        this.$store.dispatch('alert', {
          text: 'Player successfully assigned to radio',
          color: 'success'
        })

        this.modalVisible = false
      } catch (e) {
        this.$store.dispatch('alert', {
          text: 'There were some errors submitting player updates',
          color: 'error'
        })
        throw e
      } finally {
        this.submitting = false
      }
    },
    async deletePlayer() {
      this.deleting = true
    }
  }
}
</script>
